import BaseRepository from "~/repositories/BaseRepository";
import UserColumnModel from "~/models/UserColumnModel";

type IndexParams = {
  q?: {
    user_account_id_eq?: number
  },
  limit?: number,
  offset?: number
}

export default class UserColumnsRepository extends BaseRepository {
  async index(params: IndexParams): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    const url = "/api/v1/user_columns";
    const results = await this._get(url, params);
    const models = [];
    results.data.forEach(result => {
      models.push(new UserColumnModel(result));
    });
    return models;
  }
}
